<template>
  <main class="carousel-actions">
    <swiper slides-per-view="auto"
            :navigation="swiperNavigation"
            :pagination="swiperPagination"
            :observer="true"
            @swiper="onSwiper">
      <swiper-slide :class="{'w-100': slides.length === 1}"
                    v-for="(slide, index) of slides"
                    :key="index">
        <div class="img bg-cover bg-center" :style="`background-image: url('${slide.result_url}')`"></div>
      </swiper-slide>
    </swiper>
    <div class="bottom-control p-4 border-t-1 border-0 border-solid"
         :class="{'flex justify-center': slides.length === 1}">
      <div class="action flex items-center justify-between">
        <div class="swiper-button swiper-button-prev static border border-solid rounded-full mt-0"
             v-show="slides.length > 1"/>
        <div class="remove-action border border-solid py-2 px-3 rounded cursor-pointer" @click="$emit('remove-slide', slides[swiper.snapIndex])">remove</div>
        <div class="swiper-button swiper-button-next static border border-solid rounded-full mt-0"
             v-show="slides.length > 1"/>
      </div>
    </div>
  </main>
</template>

<script>
import { Navigation, Pagination } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";

SwiperCore.use([Navigation, Pagination])

export default {
  name: 'CarouselActions',
  props: {
    slides: Array
  },
  components: {
    Swiper,
    SwiperSlide
  },
  data: () => ({
    swiper: null,
    swiperNavigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    swiperPagination: {
      el: ".swiper-pagination-edit",
      type: "fraction"
    }
  }),
  watch: {
    async slides(newSlides) {
      setTimeout(() => {
        this.swiper.slideTo(newSlides.length - 1, 0)
      }, 0);
    }
  },
  methods: {
    slideChange() {
      this.$emit('slide-change', this.swiper)
    },

    onSwiper(swiper) {
      this.swiper = swiper
    }
  }
};
</script>

<style scoped>
.swiper-slide {
  width: 85%;
}
.swiper-slide.w-100 {
    width: 100%;
}

.swiper-slide {
  cursor: grab;
}

.swiper-button {
  width: 20px;
  height: 20px;
}
.swiper-button:after {
    font-size: 14px;
}

.swiper-button-disabled {
  display: flex
}

.img-container,
.img {
  height: 325px;
}
</style>
